import { useState, useContext, useEffect } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import dayjs from 'dayjs';
import { AuthContext } from "../../contexts/auth";
import defLanguage from "../../utils/defLanguage";

import { getPurchasedTokens } from "../../services/getPurchasedTokens";
import { postModeration } from "../../services/openAI/moderation";

import { postHistoric } from "../../services/postHistoric";
import formatDate from "../../utils/formatDate";

import OpenAI from "openai";
import { postProfilePost } from "../../services/ayrshare/postProfilePost";
import { getConfigOpenAI } from "../../services/openAI/getConfigOpenAI";
import { getOpenAI } from "../../services/openAI/getOpenAi";
import { postDalle } from "../../services/openAI/dalle";
import formatPostDate from "../../utils/formatPostDate"
import createADMessage from "./utils/createADMessage";
import getIdAssistant from "./utils/getIdAssistant";
import generatesPublicationObject from "./utils/generatesPublicationObject";

const openai = new OpenAI({apiKey: process.env.REACT_APP_OPENAI_KEY, dangerouslyAllowBrowser: true});

const useAutoAdFromProductDescriptionState = (close) => {
    const api = 0;
    const { signOut, language } = useContext(AuthContext);

    let lang = defLanguage(language.value);

    let [sendText, setSendText] = useState("");
    let [content, setContent] = useState("a post");
    let [messageUser, setMessageUser] = useState("");
    let [tone, setTone] = useState("creative");
    let [ad, setAd] = useState("");
    let [type, setType] = useState("----");
    let [target, setTarget] = useState("all");
    let [sector, setSector] = useState("all");
    let [_language, setLanguage] = useState(lang);
    let [product, setProduct] = useState("");

    let [profileSelected, setProfileSelected] = useState(0);
    let [open, setOpen] = useState(false);
    let [messageOpen, setMessageOpen] = useState(false);
    let [hasImage, setHasImage] = useState(false);
    let [openImage, setOpenImage] = useState(false);
    let [dateTime, setDateTime] = useState(dayjs(Date.now()));
    let [returnText, setReturnText] = useState(``);
    let [isGenerateModal, setIsGenerateModal] = useState(false)
    let [progress, setProgress] = useState(0);
    let [stop, setStop] = useState(false);
    let [generating, setGenerating] = useState([]);
    let [submit, setSubmit] = useState(false);

    
    useEffect(()=>{
        
        if (generating.filter(item=>!item.finish)[0] && !stop){
            let genera = generating.filter(item=>!item.finish)[0]
            _openAILocal(genera)
        }
        if (isGenerateModal){
            let hundred = generating.length
            let finish = generating.filter(item=> item.finish).length
            let p = (finish * 100) / hundred
            setProgress(p ? p : 0)}
        }
        ,[generating])

    useEffect(()=>setIsGenerateModal(submit),[submit])
    useEffect(()=>{
        if (stop){
            setGenerating([])
            setSubmit(false)
        }
    },[stop])
    

    const _completions = async (messages, send, platform, data) => {

        let idAsssistent = getIdAssistant(platform)
    
        if (stop){
            return;
        }
        
        const awaitAssistent = async () =>{
            if (stop){
                return;
            }

            const run = await openai.beta.threads.runs.retrieve(
                thread.thread_id,
                thread.id
            );

            if (run.status === 'in_progress')
            {
                setTimeout(awaitAssistent, 500);
            }else if (run.status === 'completed')
            {
                if (stop){
                    return;
                }

                const messagesOpenAI = await openai.beta.threads.messages.list(
                    thread.thread_id,
                );
                
                let finalText = messagesOpenAI.data[0]?.content[0]?.text.value;
    
                let newSend = {...send, assistentID:idAsssistent}
                if (stop){
                    return;
                }
                await postHistoric({
                    send: JSON.stringify(newSend),
                    text: JSON.stringify(messages),
                    result: finalText,
                    date: formatDate(new Date()),
                    action: api
                })

                let image = ''

                if (hasImage){
                    setMessageUser(`${platform} - ${formatPostDate(data)}: generating publication image!`)
                    let imageDescription = `Can you suggest a simple frase for generating an image using AI (DALLE) for this post? It should be something simple and objective, so the AI will easily generate something appropriate. Remember to don't create a description that makes the AI generate faces or words, as it won't work well. Also don't use any names as AI won't generate the image well. It can be either an objective or an abstract image, depending on the text: ${finalText}`
                    let config = await getConfigOpenAI(imageDescription, 7, ()=>{}, signOut)
                    let messages = [
                        {'role': 'system', "content": "You are a helpful and creative assistant."},
                        {'role':'user', "content": imageDescription.trim()}
                    ]
                    let send = JSON.stringify({text: imageDescription.trim()});
                    let chat = await getOpenAI(messages, config)
                    await postHistoric({
                        send: send,
                        text: JSON.stringify(messages),
                        result: chat,
                        date: formatDate(new Date()),
                        action: 5
                    })
                    let json = {
                        text: chat.trim(),
                        size: 512,
                        style: 'standard',
                        date: formatDate(new Date()),
                    };
                    let dalle = await postDalle(json)
                    if (dalle?.type === "error") {
                        if (dalle.data.code === "token_not_valid") {
                            setStop(true);
                            signOut();
                        }
                        else {
                            toast.error(<FormattedMessage id={dalle.data.detail} />);
                        }
                    } else {
                        let imgs = JSON.parse(dalle.data);
                        image= imgs.urls[0]
                    }

                }
                let publis = generatesPublicationObject(finalText, 
                        image, 
                        [platform], 
                        formatDate(new Date()), 
                        data ? formatDate(new Date(data)) : formatDate(new Date()),
                        null
                )

                if (stop){
                    return
                }
                setMessageUser(`${platform} - ${formatPostDate(data)}: scheduling publication!`)
                let result = await postProfilePost(profileSelected, publis)

                let genera = generating.map((item) => {
                    if(item.channel === platform && item.publishDay.toISOString() ===data.toISOString()){
                        return { ...item, finish: true}
                    } else{
                        return item
                    } 
                })
                
                
                setGenerating(genera)
                
                if (genera.filter(item => !item.finish).length <= 0){
                    toast.success(`all publications scheduled`);
                    setMessageUser(``)
                    setSubmit(false)
                    close()
                }
                else {

                }
                
                
            }
        }

        setMessageUser(`${platform} - ${formatPostDate(data)}: generating publication text!`)
       
        const thread = await openai.beta.threads.createAndRun({
            assistant_id: idAsssistent,
            thread: {
              messages: messages,
            },
        });

        setTimeout(awaitAssistent, 500);
    
    
    }

    const AdFromProduc = async (publish) => {
        let platform = publish.channel
        let messages = createADMessage(platform, ad, type, product, tone, target, sector, sendText, _language);

        let send = {
            tone: tone, 
            type: type, 
            platform: platform, 
            target: target, 
            product: sendText, 
            the_amount: 'one', 
            ad: ad, 
            sector: sector, 
            language: _language};

        await _completions(messages,send, platform, publish.publishDay)
    }

    const _openAILocal = async (publish) => {
    
        let json = await getPurchasedTokens('tokens')

        if (json?.type === "error") {
            if (json.data.code === "token_not_valid") {
                signOut();
            } else if (
                json.data.code === "violation of guidelines"
            ) {
                toast.error(
                    <FormattedMessage id={json.data.detail} />
                );
            } else if (
                json.data.detail === "Not found."
            ) {
                toast.error(
                    <FormattedMessage id="your user has no usage tokens" />
                );
                setSubmit(false);
            }
            else {
                toast.error(<FormattedMessage id="unknown error" />);
            }
        } else {
            if (
                json.data.tokens_number <= 0
            ) {
                toast.error(
                    <FormattedMessage id="your user has no usage tokens" />
                );
                setSubmit(false);
            }
            else {
                if (stop){
                    setSubmit(false);
                    return null;
                }
                let moderation = await postModeration({text: sendText.trim(), api: api})
    
                if (moderation?.type === "error") {
                    if (moderation.data.code === "token_not_valid") {
                        signOut();
                    } else if (
                        moderation.data.code === "violation of guidelines"
                    ) {
                        toast.error(
                            <FormattedMessage id={moderation.data.detail} />
                        );
                    } else {
                        toast.error(<FormattedMessage id="unknown error" />);
                    }
                    setSubmit(false);
                } else {
                    if (
                        moderation.data.tokens_number <= 0 ||  moderation.data.tokens_number * 4 < sendText.trim().length
                    ) {
                        toast.error(
                            <FormattedMessage id="your user has no usage tokens" />
                        );
                        setSubmit(false);
                    }
                    else {
                        if (stop){
                            setSubmit(false);
                            return null;
                        }
                    
                        return AdFromProduc(publish)
                    }
                }
            }
        }
    }

    const handleAPI = async (days, hour) => {
        
        if (submit) {
            return;
        }

        let isSendTextValid = false;
        let isAdValid = false;

        if (sendText !== "") {
            isSendTextValid = true;
        } else {
            toast.error(<FormattedMessage id="Provide a valid text" />);
        }

        if (isAdValid !== "") {
            isAdValid = true;
        } else {
            toast.error(<FormattedMessage id="Provide a valid type of content" />);
        }

        if (isSendTextValid && isAdValid) {
            setSubmit(true);
            setOpen(false);
            setIsGenerateModal(true)
            setMessageUser('thinking about your publications...')

            let genera = []

            days.facebook?.forEach(day=>{
                
                let publishdayText = `${day} ${hour}`
                let publishDay = new Date(publishdayText)
                if (publishDay < new Date()){
                    return
                }
                genera.push({name:`facebook - ${publishDay}`, channel:'facebook', publishDay:publishDay, finish: false})
                
            })
            days.fbg?.forEach(day=>{
                let publishdayText = `${day} ${hour}`
                let publishDay = new Date(publishdayText)
                if (publishDay < new Date()){
                    return
                }
                genera.push({name:`fbg - ${publishDay}`, channel:'fbg', publishDay:publishDay, finish: false})
            })
            days.linkedin?.forEach(day=>{
                let publishdayText = `${day} ${hour}`
                let publishDay = new Date(publishdayText)
                if (publishDay < new Date()){
                    return
                }
                genera.push({name:`linkedin - ${publishDay}`, channel:'linkedin', publishDay:publishDay, finish: false})

            })
            days.twitter?.forEach(day=>{
                let publishdayText = `${day} ${hour}`
                let publishDay = new Date(publishdayText)
                if (publishDay < new Date()){
                    return
                }
                genera.push({name:`twitter - ${publishDay}`, channel:'twitter', publishDay:publishDay, finish: false})

            })

            setGenerating(genera)
        }

    };

    return {
        sendText: {
            value: sendText,
            set: setSendText,
        },
        tone: {
            value: tone,
            set: setTone,
        },
        type: {
            value: type,
            set: setType,
        },
        target: {
            value: target,
            set: setTarget,
        },
        ad: {
            value: ad,
            set: setAd,
        },
        sector: {
            value: sector,
            set: setSector,
        },
        language: {
            value: _language,
            set: setLanguage,
        },
        returnText: {
            value: returnText,
            set: setReturnText,
        },
        product: {
            value: product,
            set: setProduct,
        },
        messageUser: {
            value: messageUser,
            set: setMessageUser,
        },
        profileSelected: {
            value: profileSelected,
            set: setProfileSelected,
        },
        content: {
            value: content,
            set: setContent,
        },
        open: {value: open, set: setOpen},
        messageOpen: {value: messageOpen, set: setMessageOpen},
        openImage: {value: openImage, set: setOpenImage},
        dateTime: {value: dateTime, set: setDateTime},
        isGenerateModal: {value: isGenerateModal, set: setIsGenerateModal},
        progress: {value: progress, set: setProgress},
        stop: {value: stop, set: setStop},
        hasImage: {value: hasImage, set: setHasImage},
        submit: {
            value: submit,
            set: handleAPI,
        },
    };
};

export default useAutoAdFromProductDescriptionState;
